(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:ConnectedCardsBlockModalCtrl
   *
   * @description
   *
   */
  angular
    .module('accounts')
    .controller('ConnectedCardsBlockModalCtrl', ConnectedCardsBlockModalCtrl);

  function ConnectedCardsBlockModalCtrl() {
    var vm = this;
    vm.ctrlName = 'ConnectedCardsBlockModalCtrl';
    console.log("Ja sam modal");
  }
}());
